import styled from 'styled-components';

import { Button } from '../../../Toolkit/Button';

const CloseButton = styled(Button)`
  padding: 12px; // Makes the touch area 44px x 44px. 20px + 12px + 12px
  margin: -12px; // Compensates the layout for the increased touch area padding to keep the elements aligned
  cursor: pointer;
  width: auto;
  height: auto;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  // Position close button and its contents at the top of the container
  align-self: start;
  display: flex;
  align-items: center;
  justify-content: center;

  // The SharedButton styles offset all nested SVGs by 3px for some reason, so we need to override that here to allow proper centering
  svg {
    margin-top: 0;
  }
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.donedeal.spacing.M16};
`;

const IconAndTextContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.M16};
  align-items: center;
`;

export { Header, CloseButton, IconAndTextContainer };
